import React, {useEffect} from 'react';
import {ListViewProps} from 'components/list/ListView';
import {useListContext} from 'components/list/ListContext';
import SimpleList from 'components/list/SimpleList';
import {useController} from 'react-hook-form';

const ImportList = (props: ImportListProps) => {
  const {payloadList, children, ...rest} = props;

  const {list} = useListContext();

  const {
    field: {onChange: onChangeList}
  } = useController({name: payloadList});

  useEffect(() => {
    onChangeList(list || []);
  }, [list]);

  return <SimpleList {...rest}>{children}</SimpleList>;
};

type ImportListProps = ListViewProps & {
  payloadList: string;
};

export default ImportList;
